<div class="mt-4 mx-4">

  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

  <div class="tab-pane fade show active">
    <div class="card shadow-sm border-0">
      <div class="card-body">

        <!-- Header -->
        <div class="row mb-2">
          <div class="col-md-12 col-sm-12">
            <div class="p-3 rounded-3 border bg-light h-100">
              <div class="small text-muted d-flex align-items-center gap-2">
                <i class="bi bi-wallet2"></i>
                Earned Wage Withdrawals
              </div>
              <div class="fw-semibold mt-1" style="font-size:1.25rem;">
                LKR {{ (dashboard?.wageWithdrawals) | number:'1.2-2' }}
              </div>
              <div class="text-muted small mt-1">
                Click a company to expand its salary cycles. Click a cycle to view its last 6 monthly instances, then
                click <i class="bi bi-arrow-right"></i> on any instance to see individual withdrawals.
              </div>
            </div>
          </div>
        </div>

        <!-- Search -->
        <div class="col-md-12 col-sm-12 mb-2 mb-md-0">
          <div class="d-flex align-items-center gap-2 flex-nowrap">

            <!-- Search input -->
            <div class="position-relative flex-grow-1 min-width-0">
              <input id="searchUser" type="text" class="form-control user-search-input shadow-none"
                placeholder="Type here..." [(ngModel)]="companySearchText" (input)="performCompanySearch()" />

              <span class="search-icon" (click)="performCompanySearch()">
                <i class="bi bi-search"></i>
              </span>
            </div>

            <!-- Advanced Filter -->
            <div class="flex-shrink-0 advanced-filter-wrapper">
              <app-filter-panel #filterPanel title="Advanced Filter" [fields]="filterFields"
                (filterApplied)="onFilter($event)" (filterCleared)="onClear()">
              </app-filter-panel>
            </div>

          </div>
        </div>

        <!-- Loading -->
        <div *ngIf="isCompaniesLoading" class="text-muted">Loading companies...</div>

        <!-- Empty / Error -->

        <div *ngIf="!isCompaniesLoading && companiesError" class="text-center py-5">
          <i class="bi bi-inbox fs-1 text-muted mb-3 d-block"></i>
          <p class="text-muted">No records found.</p>
        </div>

        <!-- Search returned no matches (history loaded fine, but filter is empty) -->
        <div *ngIf="!isCompaniesLoading && !companiesError && filteredCompanies.length === 0 && companySearchText"
          class="text-center py-5">
          <i class="bi bi-inbox fs-1 text-muted mb-3 d-block"></i>
          <p class="text-muted">No matching results for "{{ companySearchText }}".</p>
        </div>

        <!-- Companies table -->
        <div *ngIf="filteredCompanies.length > 0 && !companiesError" class="table-responsive-wrapper">
          <table class="table table-striped">
            <thead>
              <tr>
                <th class="table-title text-start" style="width: 48px;"></th>
                <th class="table-title text-start">Company</th>
                <th class="table-title text-start">Company ID</th>
                <th class="table-title text-end">Total Withdrawals (LKR)</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let c of pagedCompanies">

                <!-- ── Company row ── -->
                <tr class="clickable-row" role="button" tabindex="0" (click)="onCompanyRowClick(c)"
                  (keydown)="onCompanyRowKeydown($event, c)">
                  <td class="text-start">
                    <button class="btn p-0" style="background:none;border:none;"
                      (click)="$event.stopPropagation(); toggleExpand(c)" [attr.aria-expanded]="isExpanded(c.companyId)"
                      [attr.aria-controls]="'cycles-row-' + c.companyId">
                      <i class="bi" [ngClass]="isExpanded(c.companyId) ? 'bi-chevron-down' : 'bi-chevron-right'"
                        style="font-size:1.05rem; color:var(--primary-color);"></i>
                    </button>
                  </td>
                  <td class="table-data-text text-start">{{ c.companyName }}</td>
                  <td class="table-data-text text-start">{{ c.companyId }}</td>
                  <td class="table-data-text text-end">{{ (c.totalWithdrawals ?? 0) | number:'1.2-2' }}</td>
                </tr>

                <!-- ── Expanded: salary cycles panel ── -->
                <tr *ngIf="isExpanded(c.companyId)" [attr.id]="'cycles-row-' + c.companyId">
                  <td></td>
                  <td colspan="3">
                    <div class="p-3 rounded-3 border bg-light">

                      <!-- Panel header -->
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <div class="small text-muted d-flex align-items-center gap-2">
                          <i class="bi bi-calendar3"></i>
                          Salary Cycles — last 6 instances each
                        </div>
                        <div class="small">
                          <span *ngIf="isCyclesLoadingMap[c.companyId]" class="text-muted">Loading…</span>
                          <span *ngIf="cyclesErrorMap[c.companyId]" class="text-danger">
                            {{ cyclesErrorMap[c.companyId] }}
                          </span>
                          <span *ngIf="!isCyclesLoadingMap[c.companyId] && !cyclesErrorMap[c.companyId]
                                        && (cyclesByCompany.get(c.companyId)?.length ?? 0) === 0" class="text-muted">No
                            salary cycles found.</span>
                        </div>
                      </div>

                      <!-- Cycles table -->
                      <div *ngIf="(cyclesByCompany.get(c.companyId)?.length ?? 0) > 0" class="table-responsive-wrapper">
                        <table class="table table-bordered mb-0">
                          <thead>
                            <tr>
                              <!-- ── NEW: expand toggle column ── -->
                              <th class="table-title text-start" style="width:40px;"></th>
                              <th class="table-title text-start">Cycle</th>
                              <th class="table-title text-start">Start</th>
                              <th class="table-title text-start">End</th>
                              <th class="table-title text-end">6-Month Total (LKR)</th>
                            </tr>
                          </thead>
                          <tbody>
                            <ng-container *ngFor="let cy of cyclesByCompany.get(c.companyId)">

                              <!-- ── Cycle summary row ── -->
                              <tr class="clickable-row"
                                (click)="toggleCycleExpand($event, c.companyId, cy.salaryCycleId)">
                                <td class="text-start">
                                  <button class="btn p-0" style="background:none;border:none;"
                                    (click)="toggleCycleExpand($event, c.companyId, cy.salaryCycleId)"
                                    [attr.aria-expanded]="isCycleExpanded(c.companyId, cy.salaryCycleId)">
                                    <i class="bi" [ngClass]="isCycleExpanded(c.companyId, cy.salaryCycleId)
                                                  ? 'bi-chevron-down' : 'bi-chevron-right'"
                                      style="font-size:0.95rem; color:var(--primary-color);"></i>
                                  </button>
                                </td>
                                <td class="table-data-text text-start fw-semibold">
                                  {{ cy.salaryCycleName }}
                                </td>
                                <td class="table-data-text text-start">
                                  {{ cy.currentInstance?.cycleStart | date:'yyyy-MM-dd' }}
                                </td>
                                <td class="table-data-text text-start">
                                  {{ cy.currentInstance?.cycleEnd | date:'yyyy-MM-dd' }}
                                </td>
                                <td class="table-data-text text-end">
                                  {{ (cy.totalWithdrawals) | number:'1.2-2' }}
                                </td>
                              </tr>

                              <!-- ── NEW: Instance sub-rows (shown when cycle expanded) ── -->
                              <ng-container *ngIf="isCycleExpanded(c.companyId, cy.salaryCycleId)">

                                <!-- Sub-header -->
                                <tr class="instance-subheader-row">
                                  <td></td>
                                  <td colspan="4">
                                    <div class="instance-subheader">
                                      <i class="bi bi-clock-history me-1"></i>
                                      Monthly Instances
                                    </div>
                                  </td>
                                </tr>

                                <!-- One row per instance -->
                                <tr *ngFor="let inst of cy.instances; let i = index" class="instance-row"
                                  [class.instance-row--current]="i === 0">
                                  <td></td>
                                  <!-- Current badge -->
                                  <td class="table-data-text text-start ps-4">
                                    {{ inst.cycleStart | date:'yyyy-MM-dd' }}
                                    <span *ngIf="i === 0" class="badge bg-success me-2" style="font-size:10px;">
                                      CURRENT
                                    </span>
                                  </td>
                                  <td class="table-data-text text-start">
                                    {{ inst.cycleStart | date:'yyyy-MM-dd' }}
                                  </td>
                                  <td class="table-data-text text-start">
                                    {{ inst.cycleEnd | date:'yyyy-MM-dd' }}
                                  </td>
                                  <td
                                    class="table-data-text text-end d-flex align-items-center justify-content-end gap-3">
                                    <span [class.text-muted]="!(inst.totalWithdrawals > 0)">
                                      {{ (inst.totalWithdrawals ?? 0) | number:'1.2-2' }}
                                    </span>
                                    <!-- ── Navigate into instance withdrawals ── -->
                                    <button class="btn p-0" style="background:none;border:none;"
                                      (click)="openCycleInstance($event, c, cy, inst)" data-bs-toggle="offcanvas"
                                      data-bs-target="#cycleWithdrawalsOffcanvas"
                                      title="View withdrawals for this period">
                                      <i class="bi bi-arrow-right"
                                        style="font-size:1.1rem; color:var(--primary-color);"></i>
                                    </button>
                                  </td>
                                </tr>

                                <!-- Spacer after instances -->
                                <tr class="instance-spacer-row">
                                  <td colspan="5"></td>
                                </tr>

                              </ng-container>
                              <!-- /instance sub-rows -->

                            </ng-container>
                          </tbody>
                        </table>
                      </div>
                      <!-- /cycles table -->

                    </div>
                  </td>
                </tr>
                <!-- /expanded row -->

              </ng-container>
            </tbody>
          </table>

          <!-- Pagination -->
          <!-- <app-paginator [dataSource]="filteredCompanies" [pageSize]="10" [pageSizeOptions]="[5, 10, 20, 50]"
            (pageChange)="onCompaniesPageChange($event)">
          </app-paginator> -->
          <app-paginator [serverSide]="true" [totalItems]="totalCompanies" [pageSize]="companiesPageSize"
            [pageSizeOptions]="companiesPageSizeOptions" (pageChangeServer)="onCompaniesPageChange($event)">
          </app-paginator>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- ── Offcanvas: Instance Withdrawals ── -->
<div class="offcanvas offcanvas-end w-70" tabindex="-1" id="cycleWithdrawalsOffcanvas"
  aria-labelledby="cycleWithdrawalsOffcanvasLabel" data-bs-backdrop="static" data-bs-keyboard="false">

  <div class="offcanvas-header">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-10 d-flex align-items-center">
          <h5 class="offcanvas-title d-flex align-items-center gap-2 mb-0" id="cycleWithdrawalsOffcanvasLabel">
            <i class="bi fs-5 bi-receipt"></i>
            {{ selectedCompany?.companyName || 'Company' }}
            — {{ selectedCycle?.salaryCycleName || 'Cycle' }}
            <!-- ── NEW: show which instance period is open ── -->
            <!-- <span *ngIf="selectedInstance" class="badge bg-secondary ms-2" style="font-size:12px; font-weight:500;">
              {{ selectedInstance.cycleStart | date:'yyyy-MM-dd' }}
            </span>
            <span *ngIf="selectedInstance" class="badge bg-secondary ms-2" style="font-size:12px; font-weight:500;">
              {{ selectedInstance.cycleEnd | date:'yyyy-MM-dd' }}
            </span> -->
          </h5>
        </div>
        <div class="col-2 text-end">
          <span type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></span>
        </div>
      </div>
    </div>
  </div>

  <div class="offcanvas-body">
    <div *ngIf="selectedInstance">

      <!-- Filters -->
      <div class="row g-3 align-items-end">

        <div class="col-12 col-lg-3">
          <label class="label-text">Start Date</label>
          <input type="date" class="form-control rounded-pill shadow-none input-text" [(ngModel)]="startDate"
            [max]="endDate || todayYMD" (change)="onDateRangeChange()" (keyup.enter)="onDateRangeChange()" />
        </div>

        <div class="col-12 col-lg-3">
          <label class="label-text">End Date</label>
          <input type="date" class="form-control rounded-pill shadow-none input-text" [(ngModel)]="endDate"
            [min]="startDate || null" [max]="todayYMD" (change)="onDateRangeChange()"
            (keyup.enter)="onDateRangeChange()" />
        </div>

        <div class="col-12 col-lg">
          <label class="label-text">Search</label>
          <input type="text" class="form-control user-search-input shadow-none" placeholder="Type here..."
            [(ngModel)]="withdrawalSearchText" (input)="performWithdrawalSearch()" />
        </div>

        <!-- Advanced Filter -->
        <div class="col-12 col-lg-auto d-flex justify-content-end justify-content-lg-start align-items-end">
          <app-filter-panel #filterPanel title="Advanced Filter" [fields]="withdrawalsFilterFields"
            (filterApplied)="onWithdrawalsFilter($event)" (filterCleared)="onWithdrawalsFilterClear()">
          </app-filter-panel>
        </div>

      </div>

      <!-- States -->
      <div class="mt-3" *ngIf="isWithdrawalsLoading">Loading withdrawals...</div>

      <div *ngIf="!isWithdrawalsLoading && withdrawalsError" class="text-center py-5">
        <i class="bi bi-inbox fs-1 text-muted mb-3 d-block"></i>
        <p class="text-muted">No withdrawals found for the selected period.</p>
      </div>

      <!-- Search returned no matches (history loaded fine, but filter is empty) -->
      <div
        *ngIf="!isWithdrawalsLoading && !withdrawalsError && filteredWithdrawals.length === 0 && withdrawalSearchText"
        class="text-center py-5">
        <i class="bi bi-inbox fs-1 text-muted mb-3 d-block"></i>
        <p class="text-muted">No matching results for "{{ withdrawalSearchText }}".</p>
      </div>

      <!-- Withdrawal table -->
      <div *ngIf="filteredWithdrawals.length > 0 && !withdrawalsError" class="table-responsive-wrapper mt-3">
        <table class="table table-striped">
          <thead>
            <tr>
              <th class="table-title text-start">Date &amp; Time</th>
              <th class="table-title text-start">Employee ID</th>
              <th class="table-title text-start">Name</th>
              <th class="table-title text-start">Email</th>
              <th class="table-title text-start">Mobile</th>
              <th class="table-title text-end">Amount (LKR)</th>
              <th class="table-title text-end">Fee (LKR)</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let w of pagedWithdrawals">
              <td class="table-data-text text-start">{{ w.createdDate | date:'yyyy-MM-dd, h:mm:ss a' }}</td>
              <td class="table-data-text text-start">{{ w.employeeId }}</td>
              <td class="table-data-text text-start">{{ formatName(w) }}</td>
              <td class="table-data-text text-start">{{ w.email }}</td>
              <td class="table-data-text text-start">{{ w.mobileNumber }}</td>
              <td class="table-data-text text-end">{{ (w.withdrawAmount ?? 0) | number:'1.2-2' }}</td>
              <td class="table-data-text text-end">{{ (w.transferFeeDeduction ?? 0) | number:'1.2-2' }}</td>
            </tr>
          </tbody>
        </table>

        <!-- <app-paginator [dataSource]="filteredWithdrawals" [pageSize]="10" [pageSizeOptions]="[5, 10, 20, 50]"
          (pageChange)="onWithdrawalPageChange($event)">
        </app-paginator> -->
        <app-paginator [serverSide]="true" [totalItems]="totalWithdrawals" [pageSize]="withdrawalsPageSize"
          [pageSizeOptions]="withdrawalsPageSizeOptions" (pageChangeServer)="onWithdrawalPageChange($event)">
        </app-paginator>
      </div>

    </div>
  </div>
</div>